<template>
	<div class="card-prize bg-secondary-800 rounded-lg p-4 flex flex-col gap-2">
		<div
			v-if="props.loading"
			class="animate-pulse w-full smm:w-72 h-72 rounded-md bg-neutral-50 bg-opacity-30"
		/>
		<div
			v-else
			class="flex justify-center items-center max-h-80 h-full"
		>
			<img
				:src="content.image"
				:alt="content.name"
				:title="content.name"
				width="290px"
				height="290px"
				loading="lazy"
				class="w-auto max-h-72 h-auto rounded-lg"
			/>
		</div>
		<p class="text-neutral-50 text-sm sm:text-base font-semibold sm:font-normal">{{ content.name }}</p>
	</div>
</template>

<script setup>
defineOptions({
	name: 'CardPrize',
})

const props = defineProps({
	content: {
		type: Object,
		required: true,
	},
	loading: {
		type: Boolean,
		default: false,
	},
})
</script>

<style lang="postcss">
.card-prize {
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
}
</style>
